const $ = require('jquery')

const ajaxLoader = require('./ajaxLoader')
const { URL_API } = require('./api')

// ------------------------------------
// Custom tooltips
// ------------------------------------
const Tooltips = {
  init () {
    this.buildTooltips()
    this.loadDataTooltips()
  },
  buildTooltips () {
    $('.custom-tooltip').each(function() {
      const _ = $(this)
      const data = _.next('.custom-tooltip__data')

      if (data) {
        if (_.is('[data-ct-nowrap]')) {
          _.addClass('custom-tooltip__wrapper')
          _.append(data)
        } else {
          _.wrap('<span class="custom-tooltip__wrapper"></span>')
          _.parent().append(data)
        }
      }
    })
  },
  loadDataTooltips () {
    const $customTooltipWrap = $('.custom-tooltip[data-ct-load]')

    if ($customTooltipWrap.exists()) {
      $(document).on('click', '.custom-tooltip[data-ct-load]', function(e) {
        e.preventDefault()
        e.stopPropagation()

        const $this = $(this)
        const tooltipsSiblings = $this.siblings()
        const getSel = $this.closest('.offer-list-item__wrapper')
        const getHotelId = getSel.data('hotelcode')
        const tooltipAlimentationURL = `${URL_API.LoadOfferFood}?objectCode=${getHotelId}`
        const tooltipAirportsURL = `${URL_API.LoadOfferAirports}?objectCode=${getHotelId}`

        if ($this.is('[data-ct-airports]')) {
          setTooltipType(tooltipAirportsURL, 'Airports')
        }
        if ($this.is('[data-ct-alimentation]')) {
          setTooltipType(tooltipAlimentationURL, 'Food')
        }

        if ($this.hasClass('show')) {
          $this.removeClass('show')
        } else {
          $this.addClass('show')
        }

        if (tooltipsSiblings.hasClass('show')) {
          tooltipsSiblings.removeClass('show')
        }

        function setTooltipType (_urlAjax, _templateName) {
          const ctItem = $this
          const ctWrap = ctItem.find('.custom-tooltip__data')
          const _placeholder = ctItem.find('.custom-tooltip__wrapper')
          if (!ctWrap.exists()) {
            //Console.log('data', getHotelId)
            ajaxLoader.init({
              devTest: false,
              url: _urlAjax,
              method: 'GET',
              templateName: _templateName,
              placeholder: ctItem.find('.custom-tooltip__wrapper'),
              type: 'tooltip',
              beforeSendRequest () {
                _placeholder.append('<span class="loader-gif"></span>')
              },
              afterSuccess () {
                _placeholder
                  .find('.loader-gif')
                  .fadeOut(100)
                  .delay(100).remove()

                $this.addClass('show')
              },
            })
          }
        }
      })

      $(document).on('click', function(e) {
        if ($(e.target).closest('.custom-tooltip[data-ct-load].show').length === 0) {
          $customTooltipWrap.removeClass('show')
        }
      })
    }
  },
}

module.exports = Tooltips




// WEBPACK FOOTER //
// ./src/modules/tooltips.js